export const constants = {};
export const routes = {
    "Help_Login": "help_login",
    "Create_Account": "create_account",
    "MapBase": "mapbase",
    "Login": "login",
    "Itinerary": "itinerary",
    "Settings": "settings",
    "MapBaseBK": "mapbasebk",
    "Home": "home",
};
export const pushSettings = {
    appID: 'e28ec6d6-3545-4adc-96f1-a15a4f778b3e',
    baseUrl: 'https://api.appery.io/rest/push/reg',
    baseSendUrl: 'https://api.appery.io/rest/push/msg',
    initOptions: {}
};
export const projectInfo = {
    guid: "e28ec6d6-3545-4adc-96f1-a15a4f778b3e",
    name: "NeurTravel",
    description: ""
};
export const pwaInfo = {
    name: 'NeurTravel',
    shortName: 'NeurTravel',
    description: '',
    icon: ''
};
export const IGNORED_VALUE = Symbol.for("AIO_REST_IGNORED_VALUE");
export const apiHost = "https://api.appery.io";
export const defaultProxy = "a1598193-9adf-49dc-a706-a03ee4c9f434";